module.exports = __webpack_public_path__ + "img/cbsnews.06f7390d.png";